import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-Coming-soon',
  templateUrl: './Coming-soon.component.html',
  styleUrls: ['./Coming-soon.component.css']
})
export class ComingSoonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
